import React, { useState } from "react";

function UUIDGenerator() {
    const [uuid, setUuid] = useState("");
    const [isCopied, setIsCopied] = useState(false);

    const generateUuid = () => {
        setUuid(crypto.randomUUID());
        setIsCopied(false); // Reset the copied state when generating a new UUID
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(uuid).then(() => {
            setIsCopied(true);
            //alert("UUID copied to clipboard!");
        }).catch(err => {
            alert("Failed to copy UUID: "+ err);
        });
    };

    return (
        <div className="tool">
            <h2>UUID Generator</h2>
            <div className="uuid-content">
                <input
                    type="text"
                    value={uuid}
                    readOnly
                    placeholder="Generated UUID"
                />
                <div className="button-container">
                    <button onClick={generateUuid}>Generate</button>
                    <button
                        className={`styled-button ${isCopied ? 'copied' : ''}`}
                        onClick={copyToClipboard}
                    >
                        {isCopied ? "Copied!" : "Copy to Clipboard"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UUIDGenerator;

